import React from 'react';
import { List, Filter, Datagrid, required,
		TextField,  UrlField, NumberField, 
		DateInput, ReferenceInput, SelectInput } from 'admin-on-rest';
import CHEurField from '../utils/CHEurField';

const GridFilters = (props) => (
    <Filter {...props}>
		<ReferenceInput label="Cloudhints site" source="cloudhintsdomains_id" linkType={false} reference="admin/cloudhintsdomains" alwaysOn>
            <SelectInput optionText="title" />
        </ReferenceInput>
		
		<DateInput source="to_date" label="Tot en met datum" alwaysOn options={{
				mode: 'portrait',
				hintText: 'Kies een t/m datum',
				okLabel: 'OK',
				cancelLabel: 'Cancel',
				locale: 'nl'
			}} />
			
		<DateInput source="initialfilter_from_date" label="Van datum" defaultValue={props.date} alwaysOn options={{
				mode: 'portrait',
				hintText: 'Kies een van datum',
				okLabel: 'OK',
				cancelLabel: 'Cancel',
				locale: 'nl',
				defaultDate: props.date,
			}} />
					
    </Filter>
);


export const GcrGroupedReportList = (props) => (
 	
    <List title="Clicks & omzet per GCR (adwords referal)"  perPage={100} filters={<GridFilters date={new Date(new Date().getFullYear(), new Date().getMonth(), 1,0,0,0)} />} {...props}>
        <Datagrid>
            <TextField source="gcr" sortable={false} />
            <NumberField source="count" sortable={false} />
            <CHEurField source="cost" label="omzet" sortable={false} />			
		</Datagrid>
    </List>
);



// WEBPACK FOOTER //
// ./src/siteclicks/GcrGroupedReportList.js